import { ConfirmationModal } from "@data-display/ConfirmationModal";
import { useReducer } from "react";
import { DefaultRenderActions } from "./components/DefaultRenderActions";

/**
 * @param {String} id
 * @param {Object} managementProcess
 * @param {Array} selectedApplies
 * @param {Function} RenderActions
 * @param {Array} modals
 * @param {Function} updateApplies
 */
export const AmpActionsDispatcher = ({
  id,
  managementProcess,
  selectedApplies,
  RenderActions = DefaultRenderActions,
  modals = [],
  updateApplies,
  isLoading = false,
  disabled,
  pipeName,
  setOpenEmailModal,
}) => {
  // init reducer state with currentAction and key nextAction of modals component to open = false (ex sms1 : false)
  const globalModals = [
    ...modals,
    {
      nextAction: "confirmation",
      component: (props) => (
        <ConfirmationModal
          id={`confirmation-modal-candidate-send-offer-${props.id}`}
          key={`confirmation-modal-candidate-send-offer-${props.id}`}
          title="Changement de statut"
          textConfirmButton="Confirmer"
          textCancelButton="Annuler"
          open={props.isOpen}
          onConfirmClick={props.handleSuccessModal}
          onCancelClick={props.handleCancelModal}
          onClose={props.handleClose}
        >{`Vous êtes sur le point de changer le statut de la candidature en "${props.body}". C'est parti ?`}</ConfirmationModal>
      ),
    },
  ];

  const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), {
    currentAction: null,
    isLoading,
    ...globalModals.reduce((obj, item) => Object.assign(obj, { [item.nextAction]: false }), {}),
  });

  /**
   * handle run on click on renderAction button
   * @param {*} action
   */
  const actionDispatcher = (action) => {
    const updateState = { currentAction: action };
    if (globalModals.find((modal) => modal.nextAction === action.nextAction)) {
      updateState[action.nextAction] = true;
    } else if (typeof updateApplies === "function") {
      updateApplies({
        ids: selectedApplies.map((apply) => apply._id),
        action: "updatestatus",
        selectedApplies,
        managementProcess,
        status: action.nextStatus?.key ? action.nextStatus.key : action.nextStatus,
        currentAction: action,
      });
    }
    setState(updateState);
  };

  /**
   *  handle for onClose() Modal
   * @param {Boolean} result.success true/false
   * @param {*} result.data {meta,values}
   */
  const handleClose = (result = {}) =>
    result.success ? handleSuccessModal({ data: result.data }) : handleCancelModal({ data: result.data });

  /**
   *  handle for modal success
   * @param {*} result {meta,values}
   */
  const handleSuccessModal = ({ data = {} }) => {
    handleCloseAllModal();
    if (typeof updateApplies === "function") {
      updateApplies({
        ids: selectedApplies.map((apply) => apply._id),
        selectedApplies,
        managementProcess,
        candidates: selectedApplies
          .map((apply) => [apply?.candidate?.firstName, apply?.candidate?.lastName].filter(Boolean).join(" "))
          .filter(Boolean),
        action: "updatestatus",
        status: state.currentAction.nextStatus?.key
          ? state.currentAction.nextStatus.key
          : state.currentAction.nextStatus,
        currentAction: state.currentAction,
        ...data,
      });
    }
  };
  /**
   * handle for modal cancel
   * @param {*} result
   */
  const handleCancelModal = ({ _data = {} }) => {
    handleCloseAllModal();
  };

  /**
   * handle who close all modal
   */
  const handleCloseAllModal = () =>
    setState({
      ...globalModals.reduce((obj, item) => Object.assign(obj, { [item.nextAction]: false }), {}),
    });

  return (
    <>
      {RenderActions && (
        <RenderActions
          id={id}
          pipeName={pipeName}
          setOpenEmailModal={setOpenEmailModal}
          managementProcess={managementProcess}
          actionDispatcher={actionDispatcher}
          selectedApplies={selectedApplies}
          isLoading={isLoading}
          disabled={disabled}
        />
      )}
      {!globalModals.length
        ? null
        : globalModals.map((modal, index) => (
            <modal.component
              id={id}
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              key={index}
              fullWidth
              maxWidth="sm"
              body={state.currentAction?.name}
              isOpen={state[modal?.nextAction]}
              onClose={handleClose}
              handleSuccessModal={handleSuccessModal}
              handleCancelModal={handleCancelModal}
              selectedApplies={selectedApplies}
              action={state.currentAction}
            />
          ))}
    </>
  );
};
